/*
 * Funcionalidades de gestión de cursos que dependen de la API V2 del LMS
 * (backend LMS-050…056). Valor por defecto según lo desplegado en la API y
 * forzable por entorno con `VUE_APP_LMS_<NOMBRE>=true|false` (ver lmsFeatures.js).
 * Ninguna de esas tareas está aún en `master`: todas apagadas por defecto.
 */
const flag = (value, enabledByDefault) => (value === undefined || value === '' ? enabledByDefault : value === 'true')

export default Object.freeze({
    // FE-040 · Crear curso desde el panel (LMS-051)
    createCourse: flag(process.env.VUE_APP_LMS_CREATE_COURSE, false),
    // FE-041 · Editar la ficha del curso (LMS-050, LMS-052, LMS-054)
    editCourse: flag(process.env.VUE_APP_LMS_EDIT_COURSE, false),
    // FE-042 · Duplicar curso (LMS-055)
    duplicateCourse: flag(process.env.VUE_APP_LMS_DUPLICATE_COURSE, false),
    // FE-042 · Borrar curso con protección (LMS-056)
    deleteCourse: flag(process.env.VUE_APP_LMS_DELETE_COURSE, false),
})
